<template>
  <div class="bingo-win">
    <div v-confetti="{ particleCount: 200, duration: 5000 }" class="confetti" />
    <h1 class="text">
      {{ text }}
    </h1>
  </div>
</template>

<script setup lang="ts">
import { vConfetti } from '@neoconfetti/vue';

import { ref } from 'vue';
import { useStateStore } from '@/stores/state.store';

defineProps<{
  text: string;
}>();

const stateStore = useStateStore();

const mainColor = ref(stateStore.colors.mainColor);
const backgroundColor = ref(stateStore.colors.backgroundColor);
</script>

<style scoped lang="scss">
@import '@/assets/styleConstans';

.bingo-win {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 10px;
  color: v-bind(backgroundColor);
  background-color: v-bind(mainColor);
  opacity: 0.8;
  z-index: 20;
  overflow: hidden;
}

.confetti {
  position: absolute;
  top: 40%;
}

.text {
  font-weight: 700;
  font-size: 10em;

  @media (max-width: $media-phone) {
    font-size: 5em;
  }
}
</style>
